// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-scroller="true"] {
  overflow: hidden;
}
.scroller-scrollbar {
  display: none;
  position: absolute;
  z-index: 1000;
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}
.scroller-scrollbar.vertical {
  top: 0;
  right: 0;
  width: 3px;
  height: 100%;
  margin: 0 2px;
}
.scroller-scrollbar.vertical.scroller-inverse {
  left: 0;
  right: inherit;
}
.scroller-scrollbar.horizontal {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 3px;
  margin: 2px 0;
}
.scroller-scrollbar.horizontal.scroller-inverse {
  top: 0;
  bottom: inherit;
}
.scroller-scrollbar.scroller-active {
  display: block;
}
.scroller-scrollbar {
  background-color: #000;
  opacity: 0.32;
}
`, "",{"version":3,"sources":["webpack://./assets/sonatra-jquery-sidebar/css/scroller.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;AACf;AACA;EACE,OAAO;EACP,cAAc;AAChB;AACA;EACE,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;AACf;AACA;EACE,MAAM;EACN,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,aAAa;AACf","sourcesContent":["[data-scroller=\"true\"] {\r\n  overflow: hidden;\r\n}\r\n.scroller-scrollbar {\r\n  display: none;\r\n  position: absolute;\r\n  z-index: 1000;\r\n  border-top-right-radius: 2px;\r\n  border-top-left-radius: 2px;\r\n  border-bottom-right-radius: 2px;\r\n  border-bottom-left-radius: 2px;\r\n}\r\n.scroller-scrollbar.vertical {\r\n  top: 0;\r\n  right: 0;\r\n  width: 3px;\r\n  height: 100%;\r\n  margin: 0 2px;\r\n}\r\n.scroller-scrollbar.vertical.scroller-inverse {\r\n  left: 0;\r\n  right: inherit;\r\n}\r\n.scroller-scrollbar.horizontal {\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  height: 3px;\r\n  margin: 2px 0;\r\n}\r\n.scroller-scrollbar.horizontal.scroller-inverse {\r\n  top: 0;\r\n  bottom: inherit;\r\n}\r\n.scroller-scrollbar.scroller-active {\r\n  display: block;\r\n}\r\n.scroller-scrollbar {\r\n  background-color: #000;\r\n  opacity: 0.32;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
